export default "__VITE_PUBLIC_ASSET__5cd82ce1__"